import script from "./SelectOrderStatusField.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectOrderStatusField.vue?vue&type=script&lang=ts&setup=true"

import "./SelectOrderStatusField.vue?vue&type=style&index=0&id=f5740ffa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5740ffa"]])

export default __exports__